import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
// import { AuthService } from 'src/app/shared/services/auth-service.service';
import { OAuthService } from 'src/app/shared/services/oauth.service';
import { LoggerService } from 'src/app/shared/services/logger.service';

@Component({
    selector: 'app-signout-callback',
    template: `<div>{{"Logging out..."|translate}}</div>`,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class SignoutRedirectCallbackComponent implements OnInit {
  constructor(
    private _authService: OAuthService,
    private router: Router,
    private logger: LoggerService
  ) { }

  // Both paths land on /logged-out: the local session is cleared either way, and
  // sending the user to '/' only bounced them straight into the login redirect.
  ngOnInit() {
    this._authService.finishLogout()
      .then(_ => {
        this.router.navigate(['/logged-out'], { replaceUrl: true });
      })
      .catch(error => {
        this.logger.errorWithContext('SignoutCallback', 'Logout completion failed', error);
        this.router.navigate(['/logged-out'], { replaceUrl: true });
      });
  }
}
